<template>
   <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.invoices.retrieveLoader" transition="fade-transition" type="table" />
      <template v-else>
        <v-col v-if="!creditnotesList.length" class="text-center py-5">
          <v-icon class="d-block" color="secondary" size="70">mdi-file</v-icon>
          <span class="d-block subtitle-1">No existen notas de crédito</span>
        </v-col>
        <template v-else>
          <v-data-table :headers="headers" :items="creditnotesList" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(creditnotesList) => { hasLink ? $router.push({ name: 'CreditNoteRetrieve', params: { id: creditnotesList.id } }) : ''}" style="cursor: pointer">
          <!-- header -->
            <template v-slot:header="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.invoice.customer`]="{item}">
              <div class="text-left py-4">
                <v-menu open-on-hover right offset-x :nudge-width="160" transition="slide-x-transition">
                  <template v-slot:activator="{on}">
                    <div v-on="on">
                      <span class="text--secondary font-weight-medium">{{item.invoice.customer.name}}</span>
                    </div>
                  </template>
                  <v-card class="pa-0">
                    <v-subheader class="font-weight-medium background">{{item.invoice.customer.name}}</v-subheader>
                    <v-card-text class="pa-0">
                      <v-row class="mx-0">
                        <v-col cols="12" class="pb-0">
                          <span class="text--secondary font-weight-medium">Facturación</span>
                        </v-col>
                        <v-col cols="4">
                          <span class="d-block">Total</span>
                          <span class="d-block">$ {{item.invoice.customer.aggregations.sales | currency(item.invoice.currency)}}</span>
                        </v-col>
                        <v-col cols="4">
                          <span class="d-block">{{currentMonth | capitalize}}</span>
                          <span class="d-block">$ {{item.invoice.customer.aggregations.sales_current_period | currency(item.invoice.currency)}}</span>
                        </v-col>
                        <v-col cols="4">
                          <span class="d-block">Balance</span>
                          <span class="d-block">$ {{item.invoice.customer.aggregations.balance | currency(item.invoice.currency)}}</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider class="mx-3" />
                    <v-card-actions>
                      <v-spacer />
                      <v-btn :to="{name: 'CustomerRetrieveUpdate', params: {id: item.invoice.customer.id}}" text color="primary">Ver cliente <v-icon small right>mdi-arrow-right</v-icon></v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-slot:[`item.document`]="{item}">
              <div class="text-left py-2">
                <span class="d-block">{{item.document.name}}</span>
                <span class="d-block body-2 text--secondary font-weight-medium">Nº {{item.number}}</span>
              </div>
            </template>
            <template v-slot:[`item.document.date`]="{item}">
              <span>{{item.document.date | date}}</span>
            </template>
            <template v-slot:[`item.invoice.document`]="{item}">
              <div class="text-left py-2">
                <v-menu open-on-hover right offset-x :nudge-width="160" transition="slide-x-transition">
                  <template v-slot:activator="{on}">
                    <div v-on="on">
                      <span class="d-block">{{item.invoice.document.name}}</span>
                      <span class="d-block body-2 text--secondary font-weight-medium" v-if="item.invoice.status !== 'draft'">Nº {{item.invoice.number}} • {{item.invoice.date | date}}</span>
                    </div>
                  </template>
                  <v-card>
                    <v-subheader class="font-weight-medium background">{{item.invoice.document.name}}</v-subheader>
                    <v-card-text>
                      <v-list-item class="px-0">
                        <v-list-item-title class="text--secondary font-weight-medium">Productos</v-list-item-title>
                      </v-list-item>
                      <template v-if="item.invoice.lines.length">
                        <v-list-item class="px-0 my-1" v-for="p in item.invoice.lines.slice(0, 3)" :key="p.id">
                          <v-list-item-title>
                            <span class="d-block">{{p.name}}</span>
                            <span class="d-block font-italic text--disabled">{{p.quantity}} unidades</span>
                          </v-list-item-title>
                          <v-list-item-subtitle class="text-right">{{p.amount | currency(item.invoice.currency)}} {{item.invoice.currency}}</v-list-item-subtitle>
                        </v-list-item>
                      </template>
                      <v-list-item class="px-0 my-1" v-if="item.invoice.lines.length > 3">
                        <v-list-item-title>y otros {{item.invoice.lines.length - 3}} productos</v-list-item-title>
                      </v-list-item>
                    </v-card-text>
                    <v-divider class="mx-4" />
                    <v-card-actions>
                      <v-spacer />
                      <v-btn :to="{name: item.invoice.status === 'draft' ? 'InvoiceUpdate' : 'InvoiceRetrieve', params: {id: item.invoice.id}}" text color="primary">Ver detalle <v-icon small right>mdi-arrow-right</v-icon></v-btn>
                       <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-slot:[`item.invoice.total`]="{item}">
              <div class="text-right">
                <span class="body-2 text--secondary font-weight-medium">{{item.invoice.total | currency(item.invoice.currency)}}</span>
                <span class="ml-1">{{item.invoice.currency}}</span>
              </div>
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <v-col cols="12" class="text-center" v-if="showAll">
                <v-btn :to="{name: 'InvoiceList', query: showCriteria}" outlined color="secondary">Ver todas las facturas</v-btn>
              </v-col>
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Cliente', value: 'invoice.customer', class: 'font-weight-bold', sortable: true },
      { text: 'Documento', value: 'document' },
      { text: 'Fecha', value: 'document.date', align: 'end', sortable: true },
      { text: 'Anulación', value: 'invoice.document' },
      { text: 'Total', value: 'invoice.total', align: 'end', sortable: true }
    ]
  }),
  computed: mapState({
    count: state => state.invoices.creditnotesCount,
    creditnotesList: state => state.invoices.creditnotesList
  })
}
</script>